import React from 'react';
import { Row, Col, Typography, Button } from "antd";
import './style.less';

const { Title, Text } = Typography;

const ThankYouPage = () => (
  <div className="gx-app-login-wrap gx-thank-you-page">
    <div className="gx-app-login-container">
      <Row className="gx-app-login-main-content">
        <Col xl={24} lg={24} md={24} sm={24} xs={24} className="thank-you-content">
          <div style={{ textAlign: 'center'}}>            
            <img src={require('assets/images/LogoUniserved.png')} alt='Logo' />
            <Title level={1}>Thank You!</Title>
            <Text style={{ display: "block", fontSize: 20, marginBottom: 10 }}>Your registration was successful.</Text>
            <Text style={{ display: "block", fontSize: 16, marginBottom: 25 }}>We appreciate your interest. You will receive a confirmation email shortly.</Text>
            <a href="/partner-login" style={{ color: "#630086", fontWeight: "bold" }}>
              <Button type="primary">Back to Login</Button>
            </a>
          </div>
        </Col>
      </Row>
    </div>
  </div>
);

export default ThankYouPage;